import { isEmpty } from "./isEmpty"

type ConvertToLocaleParams = {
  amount: number
  currency_code: string
  minimumFractionDigits?: number
  maximumFractionDigits?: number
  locale?: string
}

export const convertToLocale = ({
  amount,
  currency_code,
  minimumFractionDigits,
  maximumFractionDigits,
  locale = "cs-CZ", // Czech store: "890 Kč", not "CZK 890.00"
}: ConvertToLocaleParams) => {
  // A missing amount must never reach the shopper as a price. Medusa types line-item totals as
  // optional, and Intl.NumberFormat turns undefined/NaN into the literal string "NaN Kč" — which is
  // what a customer would have read in their cart. One guard here covers every price on the store,
  // and an em dash says "not known yet" instead of stating a wrong number.
  if (typeof amount !== "number" || !Number.isFinite(amount)) return "—"

  // Czech retail shows whole koruna (no haléř) unless the caller asks for decimals.
  const isCzk = currency_code?.toLowerCase() === "czk"
  return currency_code && !isEmpty(currency_code)
    ? new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency_code,
        minimumFractionDigits: minimumFractionDigits ?? (isCzk ? 0 : undefined),
        maximumFractionDigits: maximumFractionDigits ?? (isCzk ? 0 : undefined),
      }).format(amount)
    : amount.toString()
}
